import Vue from 'vue'
import { BModal, BButton, BFormCheckbox } from 'bootstrap-vue'

// Single source of truth for consent storage keys, keyed by version so
// distinct consent flows (Eureka, MCP, ...) are tracked independently.
// Do not change the Eureka version - it would re-prompt users who already consented.
const DEFAULT_VERSION = 'eureka_consent_20250711'
const consentKey = (version) => version || DEFAULT_VERSION

const DEFAULT_TITLE = 'AI Form Analysis Consent'
const DEFAULT_HEADING = 'By enabling AI Form Analysis, you accept the '

const ConsentDialog = Vue.extend({
  components: { BModal, BButton, BFormCheckbox },
  data() {
    return {
      show: false,
      consent: false,
      title: DEFAULT_TITLE,
      heading: DEFAULT_HEADING,
      resolve: null,
      reject: null
    }
  },
  methods: {
    open(options) {
      options = options || {}
      this.consent = false
      this.title = options.title || DEFAULT_TITLE
      this.heading = options.heading || DEFAULT_HEADING
      this.show = true
      return new Promise((res, rej) => {
        this.resolve = res
        this.reject  = rej
      })
    },
    onOk() {
      this.show = false
      this.resolve(true)
    },
    onCancel() {
      this.show = false
      this.resolve(false)
    },
    onCheckboxInput(v) {
      this.consent = v
    }
  },
  render(h) {
    return h(
      'b-modal',
      {
        props: {
          visible: this.show,
          title: this.title,
          okTitle: 'I Agree',
          cancelTitle: 'Take me back',
          okDisabled: !this.consent,
          hideFooterClose: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          footerClass: 'pt-0',
          cancelVariant: 'white',
          okVariant: 'success',
        },
        on: {
          ok:     this.onOk,
          cancel: this.onCancel,
          close:  this.onCancel
        }
      },
      [
        h('span', this.heading),
        h('a',
          {
            attrs: {
              href: 'https://exatom.io/ai-terms/',
              target: '_blank'
            },
          },
          'AI Terms'
        ),
        h('span', ' and authorise Exatom to transmit user-interface data, data-collection data, analytics data, and any text or images you input or upload to our AI provider (OpenAI); no directly identifying personal data (such as your name or e-mail address) is shared, and all inputs and outputs are treated as confidential and are excluded from third-party model-training.'),
        h(
          'b-form-checkbox',
          {
            attrs: { class: 'mt-3' },
            props: { checked: this.consent },
            on: { change: this.onCheckboxInput }
          },
          'I have read and agree to the Exatom AI Terms'
        )
      ]
    )
  }
})

export default {
  install(Vue, options) {
    const router = options && options.router
    const instance = new ConsentDialog().$mount()
    document.body.appendChild(instance.$el)

    // Helper to check consent without opening the modal
    Vue.prototype.$hasAIConsent = (version) => {
      try { return !!localStorage.getItem(consentKey(version)) } catch (e) { return false }
    }

    Vue.prototype.$msgBoxAIConsent = async (options) => {
      const version = options && options.version
      if (!Vue.prototype.$hasAIConsent(version)) {
        const ok = await instance.open(options)
        if (ok) {
          localStorage.setItem(consentKey(version), true)
          return true
        }
      } else {
        return true
      }

      // Use the router property to navigate to the dashboard (only if not already there)
      if (router) {
        const cr = router.currentRoute || {}
        const alreadyOnDashboard = cr.name === 'dashboard' || cr.path === '/'
        const stayOnCancel = cr.meta?.stayOnAIConsentCancel === true || cr.name === 'onboarding'
        if (!alreadyOnDashboard && !stayOnCancel) {
          try { await router.push({ name: 'dashboard' }) } catch (e) { /* ignore duplicate nav */ }
        }
      }
      return false
    }
  }
}
